import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";
import TestsRequests from "services/tests";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddVowDialog({ open, handleClose }) {
  const [count, setcount] = useState(0);
  const [description, setDescription] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAddUserAccess = () => {
    const req = {
        count: count,
        topic: "rb1405",
        description: description,
    }
    dispatch(TestsRequests.addVow(req));
    handleClose();
    reset();
  };

  const reset = () => {
    setcount("");
    setDescription("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          اضافه کردن کلید
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>تعداد</Typography>
            <TextField
              id="CountInput"
              label="تعداد"
              type="number"
              variant="outlined"
              className={classes.customInput}
              value={count}
              onChange={(e) => setcount(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>توضیحات</Typography>
            <TextField
              id="descriptionInput"
              label="توضیحات"
              variant="outlined"
              className={classes.customInput}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddUserAccess} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
